<div class="spinner-wrapper" *ngIf="showLoader">
  <mat-spinner></mat-spinner>
</div>
<section class="example-section">
  <mat-progress-bar class="example-margin" [color]="color" [mode]="mode" [value]="progresBarValue"
    [bufferValue]="bufferValue">
  </mat-progress-bar>
</section>
<div class="container equipment-wrapper">
  <div class="equipment-wrapper__item" *ngIf="!editMode">
    <h2 class="equipment-wrapper__item__title">
      {{ design?.hvac_dsn_descrpt }}
    </h2>
    <p class="equipment-wrapper__item__detail">
      ID: {{ design?.hvac_design_id }}<br />
    </p>
    <button mat-flat-button color="accent" [routerLink]="['/new-system']">
      Select Other Design
    </button>
  </div>
  <h2>System Design</h2>
  <hr />
  <div class="breadcrumb">
    <ul class="d-flex align-items-center breadcrumb__list">
      <li class="breadcrumb__list__list-item">
        <a class="breadcrumb__list__list-item__link" [routerLink]="['/home']">Home</a>
      </li>
      <li class="breadcrumb__list__list-item">
        <a class="breadcrumb__list__list-item__link" [routerLink]="['/new-system']">System Design</a>
      </li>
      <li class="breadcrumb__list__list-item">
        <a class="breadcrumb__list__list-item__link">{{editMode ? 'Edit System' : 'New System'}}</a>
      </li>
    </ul>
  </div>

  <div class="container design-overview-wrapper">
    <form focusInvalidInput class="form" (ngSubmit)="systemForm.form.valid && save()" #systemForm="ngForm">
      <div class="design-overview-wrapper__item">
        <div class="d-flex flex-column mb-0">
          <p class="design-overview-wrapper__item__title">Name of the system <i style="color:red;">*</i></p>
          <div *ngIf="verifySystemName">
            <label style="color:red">This Name is not available</label>
          </div>
        </div>
        <div class="position-relative w-100 ">
          <mat-spinner *ngIf="showInputLoader"></mat-spinner>
          <mat-form-field class="w-100" appearance="fill" floatLabel="always">
            <input matInput type="text " [(ngModel)]="system.name" autocomplete="off" name="systemname" (keyup)="verifySystem()"
              placeholder="System Name" (blur)="validateInputs()" [ngModelOptions]="{standalone: false}" #systemname="ngModel" required />
          </mat-form-field>
        </div>

        <mat-error *ngIf="systemForm.submitted && systemname.errors?.required" style="margin-top: -20px;margin-bottom: 40px;"> System Name Is Required
        </mat-error>

        <div class="row">

          <div
            style="float: left;width: 100%;padding-top: 15px; padding-left:10px; background-color:#000; height:60px; color:#ffffff;">
            <span class="content-header">
              Airflow
            </span>
          </div>
        </div>

      </div>
      <div class="design-overview-wrapper__item">
        <div class="d-flex">
          <div class="pe-3">
            <span class="design-overview-wrapper__item__item-number tooltip">
              2.1 <div class="right"><h3>9.</h3> Airflow design rates and run-times shall be determined using ASHRAE 62.2-2010 or later. Designers are permitted, but not required, to use published addenda and/or the 2013 or 2016 version of the standard to assess compliance. </div>
            </span>
          </div><sup class='supTooltip tooltip'> <div class="right"><h3>9.</h3> Airflow design rates and run-times shall be determined using ASHRAE 62.2-2010 or later. Designers are permitted, but not required, to use published addenda and/or the 2013 or 2016 version of the standard to assess compliance. </div>
            <b>?</b></sup>
          <div class="ps-3">
            <p class="design-overview-wrapper__item__title"> Ventilation airflow design rate & run-time meet the requirements of ASHRAE 62.2-2010, 2013, or 2016.<i style="color:red;">*</i></p>
          </div>
        </div>
        <mat-radio-group name="equipType1" #radio1="ngModel" [(ngModel)]="system.radio1"
        (change)="validateInputs()" [ngModelOptions]="{standalone: false}" required>
          <mat-radio-button value="Verified" checked="true" class="me-3">Verified
          </mat-radio-button>
          <mat-radio-button value="Not Verified" class="me-3">Not Verified</mat-radio-button>
        </mat-radio-group>
        <mat-error *ngIf="systemForm.submitted && radio1.errors?.required" style="margin-bottom: 20px;"> Ventilation Airflow Design Rate Is Required
        </mat-error>
      </div>


      <div class="design-overview-wrapper__item row">
        <div class="d-flex">
          <div class="pe-3">
            <span class="design-overview-wrapper__item__item-number">
              2.2
            </span>
          </div>
          <div class="ps-3">
            <p class="design-overview-wrapper__item__title">Ventilation airflow rate required by 62.2 for a
              continuous system <i style="color:red;">*</i></p>
          </div>
        </div>
        <div class="d-flex col-md-6 flex-column px-3">

          <mat-form-field appearance="fill" floatLabel="always">
            <input matInput type="text" [(ngModel)]="system.ventairrate" maxlength="9"
            (blur)="validateInputs()" [ngModelOptions]="{standalone: false}" name="ventairrate"
              class="example-right-align" placeholder="Condenser Manufacturer" #ventairrate='ngModel' required>
            <span class="input-group-addon">CFM</span>
          </mat-form-field>
          <mat-error *ngIf="systemForm.submitted&& ventairrate.errors?.required" style="margin-top: -20px;"> Ventilation Airflow Rate is required
          </mat-error>
        </div>
      </div>
      <div class="design-overview-wrapper__item">
        <div class="d-flex flex-wrap row">
          <div class="d-flex">
            <div class="pe-3">
              <span class="design-overview-wrapper__item__item-number">
                2.3
              </span>
            </div>
            <div class="ps-3">
              <p class="design-overview-wrapper__item__title">Design for this system</p>
            </div>
          </div>
          <div class="d-flex col-md-6 flex-column px-3">

            <p class="design-overview-wrapper__item__title">Vent. Airflow Rate<i style="color:red;">*</i> </p>

            <mat-form-field appearance="fill" floatLabel="always">
              <input matInput type="number" [(ngModel)]="system.venairflo0" maxlength="9"
              (blur)="validateInputs()" [ngModelOptions]="{standalone: false}" name="venairflo0"
                class="example-right-align" placeholder="Condenser Manufacturer" #venairflo0='ngModel' required>
              <span class="input-group-addon">CFM</span>
            </mat-form-field>
            <mat-error *ngIf="systemForm.submitted&& venairflo0.errors?.required" style="margin-top: -20px;"> Ventilation Airflow Rate is required
            </mat-error>
          </div>
          <div class="d-flex col-md-6 flex-column px-3">
            <p class="design-overview-wrapper__item__title">Run-time per cycle<i style="color:red;">*</i></p>
            <mat-form-field appearance="fill" floatLabel="always">
              <input matInput type="text" [(ngModel)]="system.runtimecyc" maxlength="9"
              (blur)="validateInputs()" [ngModelOptions]="{standalone: false}" name="runtimecyc"
                class="example-right-align" placeholder="Condenser Manufacturer" #runtimecyc='ngModel' required>
              <span class="input-group-addon">minutes</span>
            </mat-form-field>
            <mat-error *ngIf="systemForm.submitted&& runtimecyc.errors?.required" style="margin-top: -20px;"> Run-time per cycle is required
            </mat-error>
          </div>
          <div class="d-flex col-md-6 flex-column px-3">
            <p class="design-overview-wrapper__item__title" style="margin-top: 20px;position: relative;top: 15px;">Cycle time<i style="color:red;">*</i></p>
            <mat-form-field appearance="fill" floatLabel="always">
              <input matInput type="text" [(ngModel)]="system.cycletimes" maxlength="9"
              (blur)="validateInputs()" [ngModelOptions]="{standalone: false}" name="cycletimes"
                class="example-right-align" placeholder="Condenser Manufacturer" #cycletimes='ngModel' required>
              <span class="input-group-addon">minutes</span>
            </mat-form-field>
            <mat-error *ngIf="systemForm.submitted&& cycletimes.errors?.required" style="margin-top: -20px;margin-bottom: 40px;"> Cycle time is required
            </mat-error>

          </div>
        </div>


        <div class="row">

          <div
            style="float: left;width: 100%;padding-top: 15px; padding-left:10px; background-color:#000; height:60px; color:#ffffff;">
            <span class="content-header">
              System Type & Controls
            </span>
          </div>
        </div>


        <div class="design-overview-wrapper__item">
          <div class="d-flex">
            <div class="pe-3">
              <span class="design-overview-wrapper__item__item-number">
                2.4
              </span>
            </div>
            <div class="ps-3">
              <p class="design-overview-wrapper__item__title"> Specified system type :<i style="color:red;">*</i></p>
            </div>
          </div>
          <mat-radio-group name="equipType2" #specifiedsystype="ngModel" [(ngModel)]="system.specifiedsystype" style="display:grid; font-size:20px;line-height: 40px;"
          (change)="validateInputs()" [ngModelOptions]="{standalone: false}" required>
            <mat-radio-button value="Supply" checked="true" class="me-3">Supply (Fresh air ventilator/ air cycler)
            </mat-radio-button>
            <mat-radio-button value="Exhaust" class="me-3">Exhaust (Bath fan WITH smart switch)</mat-radio-button>
            <mat-radio-button value="Balanced" class="me-3">Balanced (ERV or HRV)</mat-radio-button>
          </mat-radio-group>
          <mat-error *ngIf="systemForm.submitted && specifiedsystype.errors?.required"> Specified System Type is
            required
          </mat-error>
        </div>


        <div class="design-overview-wrapper__item">
          <div class="d-flex col-md-6 flex-column">
            <div class="d-flex">
              <div class="pe-3">
                <span class="design-overview-wrapper__item__item-number">
                  2.5
                </span>
              </div>
              <div class="ps-3">
                <p class="design-overview-wrapper__item__title">Specified control location<i style="color:red;">*</i>
                </p>
              </div>
            </div>
            <mat-form-field appearance="fill" floatLabel="always">
              <input matInput type="text" [(ngModel)]="system.contlocspe" (blur)="validateInputs()"
                [ngModelOptions]="{standalone: false}" name="contlocspe" class="example-right-align"
                placeholder="(e.g., Master bath, utility room)" #contlocspe='ngModel' required>
            </mat-form-field>
          </div>
          <mat-error *ngIf="systemForm.submitted && contlocspe.errors?.required" style="margin-top: -20px;margin-bottom: 20px;"> This field is required
          </mat-error>
        </div>

        <div class="design-overview-wrapper__item">
          <div class="d-flex">
            <div class="pe-3">
              <span class="design-overview-wrapper__item__item-number">
                2.6
              </span>
            </div>
            <div class="ps-3">
              <p class="design-overview-wrapper__item__title">Specified controls allow the system to operate
                automatically, without occupant intervention <i style="color:red;">*</i></p>
            </div>
          </div>
          <mat-radio-group name="equipType3" #opwointrvntn='ngModel' [(ngModel)]="system.opwointrvntn"
          (change)="validateInputs()" [ngModelOptions]="{standalone: false}" required>
            <mat-radio-button value="Verified" checked="true" class="me-3">Verified
            </mat-radio-button>
            <mat-radio-button value="Not Verified" class="me-3">Not Verified</mat-radio-button>
          </mat-radio-group>

          <mat-error *ngIf="systemForm.submitted && opwointrvntn.errors?.required"> Specified controls allow the system
            is required
          </mat-error>

        </div>

        <div class="design-overview-wrapper__item">
          <div class="d-flex">
            <div class="pe-3">
              <span class="design-overview-wrapper__item__item-number">
                2.7
              </span>
            </div>
            <div class="ps-3">
              <p class="design-overview-wrapper__item__title">Specified controls includes readily-accessible ventilation
                override and a label has also been specified if its function is not obvious ( e.g., a label is required
                for a standalone wall switch, but not for a switch that's on the ventilation equipment)<i
                  style="color:red;">*</i></p>
            </div>
          </div>
          <mat-radio-group name="equipType4" #ventoverride='ngModel' [(ngModel)]="system.ventoverride"
          (change)="validateInputs()" [ngModelOptions]="{standalone: false}" required>
            <mat-radio-button value="Verified" checked="true" class="me-3">Verified
            </mat-radio-button>
            <mat-radio-button value="Not Verified" class="me-3">Not Verified</mat-radio-button>
          </mat-radio-group>
          <mat-error *ngIf="systemForm.submitted && ventoverride.errors?.required"> This field is required
          </mat-error>

        </div>
        <div class="design-overview-wrapper__item">
          <div class="d-flex">
            <div class="pe-3">
              <span class="design-overview-wrapper__item__item-number tooltip">
                2.8 <div class="right" style="min-width: 700px;"><h3>8.</h3> Item 2.8 applies to any outdoor air inlet connected to a ducted return of the dwelling unit HVAC system, regardless of its intended purpose (e.g., for ventilation air, make-up air, combustion air). This Item does not apply to HVAC systems without a ducted return. For example, if an outdoor air inlet connected to a ducted return is used as a dedicated source of outdoor air for an exhaust ventilation system (e.g., bath fan), the outdoor airflow must be automatically restricted when the exhaust fan is not running and in the event of an override of the exhaust ventilation system. Note that a Rater will generally measure the ventilation rate at the highest HVAC fan speed applicable to ventilation mode (e.g., if the inlet only opens when the HVAC is in ‘fan-only’ mode, it will be tested in this mode) to verify that it is ≤ 15 CFM or 15% above design value. As an alternative, measurement of the outdoor airflow can be waived if a Constant Airflow Regulating (CAR) damper with a manufacturer-specified maximum flow rate no higher than 15 CFM or 15% above the ventilation design value is installed on the inlet.
                  <h3>10.</h3> In addition, consult manufacturer requirements to ensure return air temperature requirements are met.</div>
              </span>
            </div><sup class='supTooltip tooltip'> <div class="right" style="min-width: 700px;"><h3>8.</h3> Item 2.8 applies to any outdoor air inlet connected to a ducted return of the dwelling unit HVAC system, regardless of its intended purpose (e.g., for ventilation air, make-up air, combustion air). This Item does not apply to HVAC systems without a ducted return. For example, if an outdoor air inlet connected to a ducted return is used as a dedicated source of outdoor air for an exhaust ventilation system (e.g., bath fan), the outdoor airflow must be automatically restricted when the exhaust fan is not running and in the event of an override of the exhaust ventilation system. Note that a Rater will generally measure the ventilation rate at the highest HVAC fan speed applicable to ventilation mode (e.g., if the inlet only opens when the HVAC is in ‘fan-only’ mode, it will be tested in this mode) to verify that it is ≤ 15 CFM or 15% above design value. As an alternative, measurement of the outdoor airflow can be waived if a Constant Airflow Regulating (CAR) damper with a manufacturer-specified maximum flow rate no higher than 15 CFM or 15% above the ventilation design value is installed on the inlet.
              <h3>10.</h3> In addition, consult manufacturer requirements to ensure return air temperature requirements are met.</div><b>?</b></sup>
            <div class="ps-3">
              <p class="design-overview-wrapper__item__title">For any outdoor air inlet designed to connect to a ducted return of the HVAC system, specified controls automatically restrict airflow using a motorized damper during ventilation off-cycle and occupant override.<i style="color:red;">*</i></p>
            </div>
          </div>
          <mat-radio-group name="equipType5" #useintakeright="ngModel" [(ngModel)]="system.useintakeright"
          (change)="validateInputs()" [ngModelOptions]="{standalone: false}" required>
            <mat-radio-button value="Verified" checked="true" class="me-3">Verified
            </mat-radio-button>
            <mat-radio-button value="Not Verified" class="me-3">Not Verified</mat-radio-button>
          </mat-radio-group>
          <mat-error *ngIf="systemForm.submitted && useintakeright.errors?.required"> This field is required
          </mat-error>
        </div>


        <div class="row">

          <div
            style="float: left;width: 100%;padding-top: 15px; padding-left:10px; background-color:#000; height:60px; color:#ffffff;">
            <span class="content-header">
              Sound
            </span>
          </div>
        </div>


        <div class="design-overview-wrapper__item">
          <div class="d-flex">
            <div class="pe-3">
              <span class="design-overview-wrapper__item__item-number tooltip">
                2.9 <div class="right" style="min-width:500px"><h3>11.</h3> Dwelling Unit Mechanical Ventilation System fans shall be rated for sound at no less than the airflow rate in Item 2.3. Fans exempted from this requirement include HVAC air handler fans, remote-mounted fans, and intermittent fans rated ≥ 400 CFM. To be considered for this exemption, a remote-mounted fan must be mounted outside the habitable spaces, bathrooms, toilets, and hallways and there shall be ≥ 4 ft. ductwork between the fan and intake grill. Per ASHRAE 62.2-2010, habitable spaces are intended for continual human occupancy; such space generally includes areas used for living, sleeping, dining, and cooking but does not generally include bathrooms, toilets, hallways, storage areas, closets, or utility rooms.  </div>
              </span>
            </div><sup class='supTooltip tooltip'> <div class="right" style="min-width:500px"><h3>11.</h3> Dwelling Unit Mechanical Ventilation System fans shall be rated for sound at no less than the airflow rate in Item 2.3. Fans exempted from this requirement include HVAC air handler fans, remote-mounted fans, and intermittent fans rated ≥ 400 CFM. To be considered for this exemption, a remote-mounted fan must be mounted outside the habitable spaces, bathrooms, toilets, and hallways and there shall be ≥ 4 ft. ductwork between the fan and intake grill. Per ASHRAE 62.2-2010, habitable spaces are intended for continual human occupancy; such space generally includes areas used for living, sleeping, dining, and cooking but does not generally include bathrooms, toilets, hallways, storage areas, closets, or utility rooms.  </div>
              <b>?</b></sup>
            <div class="ps-3">
              <p class="design-overview-wrapper__item__title">The Fan of the specified system is rated <= 3 sones if
                  intermittent, and <=1 sone if continuous or exempted <i style="color:red;">*</i> </p>
            </div>
          </div>
          <mat-radio-group name="equipType6" #fanratedsones="ngModel" [(ngModel)]="system.fanratedsones"
          (change)="validateInputs()" [ngModelOptions]="{standalone: false}" required>
            <mat-radio-button value="Verified" checked="true" class="me-3">Verified
            </mat-radio-button>
            <mat-radio-button value="Not Verified" class="me-3">Not Verified</mat-radio-button>
          </mat-radio-group>
          <mat-error *ngIf="systemForm.submitted && fanratedsones.errors?.required"> This field is required
          </mat-error>
        </div>

        <div class="row">

          <div
            style="float: left;width: 100%;padding-top: 15px; padding-left:10px; background-color:#000; height:60px; color:#ffffff;">
            <span class="content-header">
              Efficiency
            </span>
          </div>
        </div>

        <div class="design-overview-wrapper__item">
          <div class="d-flex">
            <div class="pe-3">
              <span class="design-overview-wrapper__item__item-number tooltip">
                2.10 <div class="right"><h3>12.</h3> Note that the ‘fan-on’ setting of a thermostat would not be an acceptable controller because it would continuously operate the HVAC fan. </div>
              </span>
            </div><sup class='supTooltip tooltip'> <div class="right"><h3>12.</h3> Note that the ‘fan-on’ setting of a thermostat would not be an acceptable controller because it would continuously operate the HVAC fan. </div>
              <b>?</b></sup>
            <div class="ps-3">
              <p class="design-overview-wrapper__item__title">If Vent System controller operates the HVAC fan, then HVAC fan operation is intermittent and either the fan type in Item 4.7 is ECM / ICM or the controls will reduce the run-time by accounting for HVAC system heating or cooling hours.  <i style="color:red;">*</i></p>
            </div>
          </div>
          <mat-radio-group name="equipType7" #fanreducevnt="ngModel" [(ngModel)]="system.fanreducevnt"
          (change)="validateInputs()"[ngModelOptions]="{standalone: false}" required>
            <mat-radio-button value="Verified" checked="true" class="me-3">Verified
            </mat-radio-button>
            <mat-radio-button value="Not Verified" class="me-3">Not Verified</mat-radio-button>
          </mat-radio-group>
          <mat-error *ngIf="systemForm.submitted && fanreducevnt.errors?.required"> This field is required
          </mat-error>

        </div>

        <div class="design-overview-wrapper__item">
          <div class="d-flex">
            <div class="pe-3">
              <span class="design-overview-wrapper__item__item-number tooltip">
                2.11 <div class="right"><h3>13.</h3> Bathroom fans with a rated flow rate ≥ 500 CFM are exempted from the requirement to be ENERGY STAR certified.</div>
              </span>
            </div>
            <div class="ps-3"><sup class='supTooltip tooltip'> <div class="right"><h3>13.</h3> Bathroom fans with a rated flow rate ≥ 500 CFM are exempted from the requirement to be ENERGY STAR certified.</div>
              <b>?</b></sup>
              <p class="design-overview-wrapper__item__title">If bathroom fans are specified as a part of this system,
                then they are ENERGY STAR certified. <i style="color:red;">*</i></p>
            </div>
          </div>
          <mat-radio-group name="equipType8" #bathroomfanses="ngModel" [(ngModel)]="system.bathroomfanses"
          (change)="validateInputs()" [ngModelOptions]="{standalone: false}" required>
            <mat-radio-button value="Verified" checked="true" class="me-3">Verified
            </mat-radio-button>
            <mat-radio-button value="Not Verified" class="me-3">Not Verified</mat-radio-button>
          </mat-radio-group>
          <mat-error *ngIf="systemForm.submitted && bathroomfanses.errors?.required"> This field is required
          </mat-error>
        </div>


        <div class="row">

          <div
            style="float: left;width: 100%;padding-top: 15px; padding-left:10px; background-color:#000; height:60px; color:#ffffff;">
            <span class="content-header">
              Air Inlet Location
            </span>
          </div>
        </div>

        <div class="design-overview-wrapper__item">
          <div class="d-flex">
            <div class="pe-3">
              <span class="design-overview-wrapper__item__item-number">
                2.12
              </span>
            </div>
            <div class="ps-3">
              <p class="design-overview-wrapper__item__title">Inlet pulls ventilation air directly from outdoors and not
                from attic, crawlspace, garage, or adjacent dwelling unit. <i style="color:red;">*</i></p>
            </div>
          </div>
          <mat-radio-group name="equipType9" #inletpullsoutdr='ngModel' [(ngModel)]="system.inletpullsoutdr"
          (change)="validateInputs()" [ngModelOptions]="{standalone: false}" required>
            <mat-radio-button value="Verified" checked="true" class="me-3">Verified
            </mat-radio-button>
            <mat-radio-button value="N/A" class="me-3">N/A</mat-radio-button>
          </mat-radio-group>
          <mat-error *ngIf="systemForm.submitted && inletpullsoutdr.errors?.required"> This field is required
          </mat-error>
        </div>

        <div class="design-overview-wrapper__item">
          <div class="d-flex mb-3">
            <div class="pe-3">
              <span class="design-overview-wrapper__item__item-number">
                2.13
              </span>
            </div>
            <div class="ps-3">
              <p class="design-overview-wrapper__item__title">Inlet is >= 2ft. above grade or roof deck; >= 10ft. of
                stretched-string distance from known contamination sources not exiting the roof, and >= 3ft from known
                sources exiting the roof. <i style="color:red;">*</i></p>
            </div>
          </div>
          <mat-radio-group name="equipType10" #inletlocation='ngModel' [(ngModel)]="system.inletlocation"
          (change)="validateInputs()" [ngModelOptions]="{standalone: false}" required>
            <mat-radio-button value="Verified" checked="true" class="me-3">Verified
            </mat-radio-button>
            <mat-radio-button value="N/A" class="me-3">N/A</mat-radio-button>
          </mat-radio-group>
          <mat-error *ngIf="systemForm.submitted && inletlocation.errors?.required"> This field is required
          </mat-error>
        </div>



        <div class="row">

          <div
            style="float: left;width: 100%;padding-top: 15px; padding-left:10px; background-color:#000; height:60px; color:#ffffff;">
            <span class="content-header">
              Room-by-Room Heating & Cooling Loads
            </span>
          </div>
        </div>



        <div class="design-overview-wrapper__item">
          <div class="d-flex flex-wrap row">
            <div class="d-flex">
              <div class="pe-3">
                <span class="design-overview-wrapper__item__item-number tooltip">
                  3.10 <div class="right"><h3>23.</h3> Orientation represents the direction that the front door of the house is facing. The designer is only required to document the loads for the orientation(s) that the house might be built in. For example, if a house plan will only be built one time in a specific orientation (e.g., a site-specific design), then the designer only needs to document the loads for this one orientation.</div>
                </span>
              </div><sup class='supTooltip tooltip'> <div class="right"><h3>23.</h3> Orientation represents the direction that the front door of the house is facing. The designer is only required to document the loads for the orientation(s) that the house might be built in. For example, if a house plan will only be built one time in a specific orientation (e.g., a site-specific design), then the designer only needs to document the loads for this one orientation.</div>
                <b>?</b></sup>
              <div class="ps-3">
                <p class="design-overview-wrapper__item__title">Design Sensible Heat Gain <i style="color:red;">*</i>
                </p>
              </div>
            </div>
            <div class="d-flex col-md-6 flex-column px-3">

              <mat-form-field appearance="fill" floatLabel="always">
                <input matInput type="text" [(ngModel)]="system.dessheatgainn" maxlength="9"
                (blur)="validateInputs()" (keyup)="sensibleHeatGain()" [ngModelOptions]="{standalone: false}" name="dessheatgainn"
                  class="example-right-align" placeholder="" #dessheatgainn='ngModel' required>
                <span class="input-group-addon">N in kBtuh</span>
              </mat-form-field>
              <mat-error class='loadErrors' *ngIf="systemForm.submitted&& dessheatgainn.errors?.required"> N in kBtuh is required
              </mat-error>
            </div>
            <div class="d-flex col-md-6 flex-column px-3">
              <mat-form-field appearance="fill" floatLabel="always">
                <input matInput type="text" [(ngModel)]="system.dessheatgainne" maxlength="9"
                (blur)="validateInputs()" (keyup)="sensibleHeatGain()" [ngModelOptions]="{standalone: false}" name="dessheatgainne"
                  class="example-right-align" placeholder="" #dessheatgainne='ngModel' required>
                <span class="input-group-addon">NE in kBtuh</span>
              </mat-form-field>
              <mat-error class='loadErrors' *ngIf="systemForm.submitted&& dessheatgainne.errors?.required"> NE in kBtuh is required
              </mat-error>
            </div>
            <div class="d-flex col-md-6 flex-column px-3">
              <mat-form-field appearance="fill" floatLabel="always">
                <input matInput type="text" [(ngModel)]="system.dessheatgaine" maxlength="9"
                (blur)="validateInputs()" (keyup)="sensibleHeatGain()" [ngModelOptions]="{standalone: false}" name="dessheatgaine"
                  class="example-right-align" placeholder="" #dessheatgaine='ngModel' required>
                <span class="input-group-addon">E in kBtuh</span>
              </mat-form-field>
              <mat-error class='loadErrors' *ngIf="systemForm.submitted&& dessheatgaine.errors?.required"> E in kBtuh is required
              </mat-error>
            </div>
            <div class="d-flex col-md-6 flex-column px-3">
              <mat-form-field appearance="fill" floatLabel="always">
                <input matInput type="text" [(ngModel)]="system.dessheatgainse" maxlength="9"
                (blur)="validateInputs()"  (keyup)="sensibleHeatGain()" [ngModelOptions]="{standalone: false}" name="dessheatgainse"
                  class="example-right-align" placeholder="" #dessheatgainse='ngModel' required>
                <span class="input-group-addon">SE in kBtuh</span>
              </mat-form-field>
              <mat-error class='loadErrors' *ngIf="systemForm.submitted&& dessheatgainse.errors?.required"> SE in kBtuh is required
              </mat-error>
            </div>
            <div class="d-flex col-md-6 flex-column px-3">
              <mat-form-field appearance="fill" floatLabel="always">
                <input matInput type="text" [(ngModel)]="system.dessheatgains" maxlength="9"
                (blur)="validateInputs()"  (keyup)="sensibleHeatGain()" [ngModelOptions]="{standalone: false}" name="dessheatgains"
                  class="example-right-align" placeholder="" #dessheatgains='ngModel' required>
                <span class="input-group-addon">S in kBtuh</span>
              </mat-form-field>
              <mat-error class='loadErrors' *ngIf="systemForm.submitted&& dessheatgains.errors?.required"> S in kBtuh is required
              </mat-error>
            </div>
            <div class="d-flex col-md-6 flex-column px-3">
              <mat-form-field appearance="fill" floatLabel="always">
                <input matInput type="text" [(ngModel)]="system.dessheatgainsw" maxlength="9"
                (blur)="validateInputs()"  (keyup)="sensibleHeatGain()" [ngModelOptions]="{standalone: false}" name="dessheatgainsw"
                  class="example-right-align" placeholder="" #dessheatgainsw='ngModel' required>
                <span class="input-group-addon">SW in kBtuh</span>
              </mat-form-field>
              <mat-error class='loadErrors' *ngIf="systemForm.submitted&& dessheatgainsw.errors?.required"> SW in kBtuh is required
              </mat-error>
            </div>
            <div class="d-flex col-md-6 flex-column px-3">
              <mat-form-field appearance="fill" floatLabel="always">
                <input matInput type="text" [(ngModel)]="system.dessheatgainw" maxlength="9"
                (blur)="validateInputs()"  (keyup)="sensibleHeatGain()" [ngModelOptions]="{standalone: false}" name="dessheatgainw"
                  class="example-right-align" placeholder="" #dessheatgainw='ngModel' required>
                <span class="input-group-addon">W in kBtuh</span>
              </mat-form-field>
              <mat-error class='loadErrors' *ngIf="systemForm.submitted&& dessheatgainw.errors?.required"> W in kBtuh is required
              </mat-error>
            </div>
            <div class="d-flex col-md-6 flex-column px-3">
              <mat-form-field appearance="fill" floatLabel="always">
                <input matInput type="text" [(ngModel)]="system.dessheatgainnw" maxlength="9"
                (blur)="validateInputs()"  (keyup)="sensibleHeatGain()" [ngModelOptions]="{standalone: false}" name="dessheatgainnw"
                  class="example-right-align" placeholder="" #dessheatgainnw='ngModel' required>
                <span class="input-group-addon">NW in kBtuh</span>
              </mat-form-field>
              <mat-error class='loadErrors' *ngIf="systemForm.submitted&& dessheatgainnw.errors?.required"> NW in kBtuh is required
              </mat-error>
            </div>
            <div class="d-flex col-md-6 flex-column px-3">
              <mat-form-field appearance="fill" floatLabel="always">
                <input matInput type="text" [(ngModel)]="system.maxheatgain" maxlength="9" (keyup)="sensibleHeatGain()"
                (blur)="validateInputs()" [ngModelOptions]="{standalone: false}" name="maxheatgain" class="example-right-align" placeholder=""
                  #maxheatgain='ngModel'>
                <span class="input-group-addon">Max Heat Gain</span>
              </mat-form-field>
            </div>
          </div>

        </div>

        <div class="design-overview-wrapper__item">
          <div class="d-flex">
            <div class="pe-3">
              <span class="design-overview-wrapper__item__item-number">
                3.11
              </span>
            </div>
            <div class="ps-3">
              <p class="design-overview-wrapper__item__title">Design Latent Heat Gain <i style="color:red;">*</i></p>
            </div>
          </div>
          <div class="d-flex col-md-6 flex-column">
            <mat-form-field appearance="fill" floatLabel="always">
              <input matInput type="text" [(ngModel)]="system.deslheatgain" (blur)="validateInputs()" (keyup)="sensibleHeatGain()"
                [ngModelOptions]="{standalone: false}" name="deslheatgain" maxlength="9" class="example-right-align"
                placeholder="" #deslheatgain='ngModel' required>
              <span class="input-group-addon">kBtuh</span>
            </mat-form-field>
            <mat-error class='loadErrors' *ngIf="systemForm.submitted&& deslheatgain.errors?.required"> Design Latent Heat Gain is required
            </mat-error>
          </div>
        </div>

        <div class="design-overview-wrapper__item">
          <div class="d-flex flex-wrap row">
            <div class="d-flex">
              <div class="pe-3">
                <span class="design-overview-wrapper__item__item-number tooltip">
                  3.12<div class="right"><h3>23.</h3> Orientation represents the direction that the front door of the house is facing. The designer is only required to document the loads for the orientation(s) that the house might be built in. For example, if a house plan will only be built one time in a specific orientation (e.g., a site-specific design), then the designer only needs to document the loads for this one orientation.</div>
                </span>
              </div><sup class='supTooltip tooltip'> <div class="right"><h3>9.</h3> Airflow design rates and run-times shall be determined using ASHRAE 62.2-2010 or later. Designers are permitted, but not required, to use published addenda and/or the 2013 or 2016 version of the standard to assess compliance. </div>
                <b>?</b></sup>
              <div class="ps-3">
                <p class="design-overview-wrapper__item__title">Design Total Heat Gain</p>
              </div>
            </div>
            <div class="d-flex col-md-6 flex-column px-3">

              <mat-form-field appearance="fill" floatLabel="always">
                <input matInput type="text" [(ngModel)]="system.destotlheatgainn" (keyup)="sensibleHeatGain()"
                  [ngModelOptions]="{standalone: false}" name="destotlheatgainn" class="example-right-align"
                  placeholder="" #destotlheatgainn='ngModel' readonly>
                <span class="input-group-addon">N</span>
              </mat-form-field>
            </div>
            <div class="d-flex col-md-6 flex-column px-3">
              <mat-form-field appearance="fill" floatLabel="always">
                <input matInput type="text" [(ngModel)]="system.destotlheatgainne" (keyup)="sensibleHeatGain()"
                  [ngModelOptions]="{standalone: false}" name="destotlheatgainne" class="example-right-align"
                  placeholder="" #destotlheatgainne='ngModel' readonly>
                <span class="input-group-addon">NE</span>
              </mat-form-field>
            </div>
            <div class="d-flex col-md-6 flex-column px-3">
              <mat-form-field appearance="fill" floatLabel="always">
                <input matInput type="text" [(ngModel)]="system.destotlheatgaine" (keyup)="sensibleHeatGain()"
                  [ngModelOptions]="{standalone: false}" name="destotlheatgaine" class="example-right-align"
                  placeholder="" #destotlheatgaine='ngModel' readonly>
                <span class="input-group-addon">E</span>
              </mat-form-field>
            </div>
            <div class="d-flex col-md-6 flex-column px-3">
              <mat-form-field appearance="fill" floatLabel="always">
                <input matInput type="text" [(ngModel)]="system.destotlheatgainse" (keyup)="sensibleHeatGain()"
                  [ngModelOptions]="{standalone: false}" name="destotlheatgainse" class="example-right-align"
                  placeholder="" #destotlheatgainse='ngModel' readonly>
                <span class="input-group-addon">SE</span>
              </mat-form-field>
            </div>
            <div class="d-flex col-md-6 flex-column px-3">
              <mat-form-field appearance="fill" floatLabel="always">
                <input matInput type="text" [(ngModel)]="system.destotlheatgains" (keyup)="sensibleHeatGain()"
                  [ngModelOptions]="{standalone: false}" name="destotlheatgains" class="example-right-align"
                  placeholder="" #destotlheatgains='ngModel' readonly>
                <span class="input-group-addon">S</span>
              </mat-form-field>
            </div>
            <div class="d-flex col-md-6 flex-column px-3">
              <mat-form-field appearance="fill" floatLabel="always">
                <input matInput type="text" [(ngModel)]="system.destotlheatgainsw" (keyup)="sensibleHeatGain()"
                  [ngModelOptions]="{standalone: false}" name="destotlheatgainsw" class="example-right-align"
                  placeholder="" #destotlheatgainsw='ngModel' readonly>
                <span class="input-group-addon">SW</span>
              </mat-form-field>
            </div>
            <div class="d-flex col-md-6 flex-column px-3">
              <mat-form-field appearance="fill" floatLabel="always">
                <input matInput type="text" [(ngModel)]="system.destotlheatgainw" (keyup)="sensibleHeatGain()"
                  [ngModelOptions]="{standalone: false}" name="destotlheatgainw" class="example-right-align"
                  placeholder="" #destotlheatgainw='ngModel' readonly>
                <span class="input-group-addon">W</span>
              </mat-form-field>
            </div>
            <div class="d-flex col-md-6 flex-column px-3">
              <mat-form-field appearance="fill" floatLabel="always">
                <input matInput type="text" [(ngModel)]="system.destotlheatgainnw" (keyup)="sensibleHeatGain()"
                  [ngModelOptions]="{standalone: false}" name="destotlheatgainnw" class="example-right-align"
                  placeholder="" #destotlheatgainnw='ngModel' readonly>
                <span class="input-group-addon">NW</span>
              </mat-form-field>
            </div>
            <div class="d-flex col-md-6 flex-column px-3">
              <mat-form-field appearance="fill" floatLabel="always">
                <input matInput type="text" [(ngModel)]="system.maxtotal" (keyup)="sensibleHeatGain()"
                  [ngModelOptions]="{standalone: false}" name="maxtotal" class="example-right-align" placeholder=""
                  #maxtotal='ngModel' readonly>
                <span class="input-group-addon">Max</span>
              </mat-form-field>
            </div>
            <div class="d-flex col-md-6 flex-column px-3">
              <mat-form-field appearance="fill" floatLabel="always">
                <input matInput type="text" [(ngModel)]="system.hrt" (keyup)="sensibleHeatGain()"
                  [ngModelOptions]="{standalone: false}" name="hrt" class="example-right-align" placeholder=""
                  #hrt='ngModel' readonly>
                <span class="input-group-addon">Min</span>
              </mat-form-field>
            </div>
          </div>

        </div>

        <div class="design-overview-wrapper__item">
          <div class="d-flex col-md-6 flex-column">
            <div class="d-flex">
              <div class="pe-3">
                <span class="design-overview-wrapper__item__item-number tooltip">
                  3.13 <div class="right"><h3>23.</h3> Orientation represents the direction that the front door of the house is facing. The designer is only required to document the loads for the orientation(s) that the house might be built in. For example, if a house plan will only be built one time in a specific orientation (e.g., a site-specific design), then the designer only needs to document the loads for this one orientation.<h3>24.</h3> Determine the orientation with the largest and smallest Total Heat Gain. Verify that the difference in Total Heat Gain between the orientation with the largest and smallest value is ≤ 6 kBtuh. If not, then assign the orientations into one or more groups until the difference is ≤ 6 kBtuh and then complete a separate National HVAC Design Report for each group </div>
                </span>
              </div><sup class='supTooltip tooltip'> <div class="right"><h3>9.</h3> Airflow design rates and run-times shall be determined using ASHRAE 62.2-2010 or later. Designers are permitted, but not required, to use published addenda and/or the 2013 or 2016 version of the standard to assess compliance. </div>
                <b>?</b></sup>
              <div class="ps-3">
                <p class="design-overview-wrapper__item__title">Maximum minus minimum total heat gain (Item 3.12) across orientations
                  <i
                    style="color:red;">*</i></p>
              </div>
            </div>
            <mat-form-field appearance="fill" floatLabel="always">
              <input matInput type="text" [(ngModel)]="system.gfh" (blur)="validateInputs()" (keyup)="sensibleHeatGain()"
                [ngModelOptions]="{standalone: false}" name="gfh" class="example-right-align" placeholder=""
                #gfh='ngModel' readonly="">
            </mat-form-field>
          </div>
        </div>

        <div *ngIf="!(system.gfh > 6)"
          style="float: left; width: 100%; padding-top: 15px; padding-left: 10px; background-color: rgb(129, 226, 118); height: 60px; color: #ffffff;">
          Designer Verified
        </div>
        <div *ngIf="system.gfh > 6"
          style="float: left; width: 100%; padding-top: 15px; padding-left: 10px; background-color: rgb(244, 11, 11); height: 70px; color: #ffffff;">
          <i><strong>
              <h5>Warning: you cannot use this design for all orientations because the Maximum - Minimum heat gain is
                greater than 6 kBTUh</h5>
            </strong></i>
        </div>


        <div class="design-overview-wrapper__item">
          <div class="d-flex col-md-6 flex-column">
            <div class="d-flex">
              <div class="pe-3">
                <span class="design-overview-wrapper__item__item-number">
                  3.14
                </span>
              </div>
              <div class="ps-3">
                <p class="design-overview-wrapper__item__title">Design Total Heat Loss <i style="color:red;">*</i></p>
              </div>
            </div>
            <mat-form-field appearance="fill" floatLabel="always">
              <input matInput type="text" [(ngModel)]="system.desttotlheatloss" maxlength="9"
                (keyup)="sensibleHeatGain()" (blur)="validateInputs()" [ngModelOptions]="{standalone: false}" name="desttotlheatloss"
                class="example-right-align" placeholder="" #desttotlheatloss='ngModel' required>
              <span class="input-group-addon">kBtuh</span>
            </mat-form-field>
            <mat-error class='loadErrors' *ngIf="systemForm.submitted&& desttotlheatloss.errors?.required"> Design Heat Loss is required
            </mat-error>
          </div>
          <br />
        </div>




        <div class="design-overview-wrapper__item">
          <div class="d-flex flex-wrap row">
            <div class="d-flex flex-column px-3">
              <div class="d-flex">
                <div class="pe-3">
                  <span class="design-overview-wrapper__item__item-number tooltip">
                    4.1 <div class="right"><h3>25.</h3> Equipment shall be selected using the maximum total heat gain in Item 3.12 and the total heat loss in Item 3.14 per ACCA Manual S, Second Edition, except that cooling ranges above ACCA Manual S limits are temporarily allowed, per Item 4.15.
                      <h3>26.</h3> As an alternative for low-load spaces, a system match-up including a single-speed compressor with a total capacity ≤ 20 kBtuh is permitted to be used in spaces with a total cooling load ≤ 15 kBtuh. A system match-up including a two-speed or variable-speed compressor with a total capacity ≤ 25 kBtuh is permitted to be used in spaces with a total cooling load ≤ 18 kBtuh.</div>
                  </span>
                </div><sup class='supTooltip tooltip'> <div class="right"><h3>9.</h3> Airflow design rates and run-times shall be determined using ASHRAE 62.2-2010 or later. Designers are permitted, but not required, to use published addenda and/or the 2013 or 2016 version of the standard to assess compliance. </div>
                  <b>?</b></sup>
                <div class="ps-3">
                  <p class="design-overview-wrapper__item__title">Equipment selected per ACCA Manual S Choose/ Add an
                    HVAC equipment profile to fill out these
                    checklist items</p>
                  <div *ngIf="currentEquipment" style="display:none"><b>{{currentEquipment}}</b></div>
                </div>

              </div>


              <mat-form-field class="example-full-width autoComplete" appearance="fill">
                <mat-label>Select Equipment</mat-label>
                <input type="text" (keyup)="searchEquipment($event)" placeholder="Select Equipment" matInput
                  [(ngModel)]="selectedEquipment" [matAutocomplete]="auto" #selectedEquipments='ngModel' aria-label="Select Equipment" [ngModelOptions]="{standalone: true}" required>
                <mat-autocomplete #auto="matAutocomplete" (ngModelChange)="validateInputs()" (optionSelected)="onEquipmentSelection($event.option.value)" [displayWith]="displaySelectedEquipment"
                  autoActiveFirstOption>
                  <mat-option *ngFor="let equipment of equipments"
                    [value]="equipment">
                    {{equipment?.equipmentname}} - {{equipment?.equipmentdescription}}
                  </mat-option>
                </mat-autocomplete>
                <mat-error class='loadErrors' *ngIf="systemForm.submitted && selectedEquipments?.errors?.required">
                  Equipment is required
                </mat-error>
              </mat-form-field>

              <div *ngIf="!currentEquipment"><i style="color:red;">* Please select equipment </i><br /></div>
              <div> <button class="btn btn-primary" [disabled]="!currentEquipment" (click)="viewSystemEquipment()"
                  type="button">
                  View Equipment
                </button></div>

              <!--
              <div class="d-flex justify-content-end">
                <p (click)="onEquipmentSelection(selectedEquipment)" class=" select">Select</p>
              </div>
              -->
            </div>
          </div>
        </div>

        <div class="row">

          <div
            style="float: left;width: 100%;padding-top: 15px; padding-left:10px; background-color:#000; height:60px; color:#ffffff;">
            <span class="content-header">
              Heating & Cooling Equipment Selection
            </span>
          </div>
        </div>

        <div class="design-overview-wrapper__item">
          <div class="d-flex">
            <div class="pe-3">
              <span class="design-overview-wrapper__item__item-number">
                4.13
              </span>
            </div>
            <div class="ps-3">
              <p class="design-overview-wrapper__item__title">Cooling Sizing % = Total Capacity (4.11) divided by
                maximum total heat gain (3.12)</p>
            </div>

          </div>
          <div [hidden]="system.coolsizingpct" class="table mb-0"> <i style="color:red;">* Need Total Capacity (4.11)
              And
              maximum total heat gain (3.12)</i> </div>{{returnFixed(system?.coolsizingpct) || 0}}

        </div>
        <div class="design-overview-wrapper__item">
          <div class="d-flex">
            <div class="pe-3">
              <span class="design-overview-wrapper__item__item-number tooltip">
                4.15<div class="right"><h3>25.</h3> Equipment shall be selected using the maximum total heat gain in Item 3.12 and the total heat loss in Item 3.14 per ACCA Manual S, Second Edition, except that cooling ranges above ACCA Manual S limits are temporarily allowed, per Item 4.15.
                  <h3>26.</h3> As an alternative for low-load spaces, a system match-up including a single-speed compressor with a total capacity ≤ 20 kBtuh is permitted to be used in spaces with a total cooling load ≤ 15 kBtuh. A system match-up including a two-speed or variable-speed compressor with a total capacity ≤ 25 kBtuh is permitted to be used in spaces with a total cooling load ≤ 18 kBtuh.</div>
              </span>
            </div><sup class='supTooltip tooltip'> <div class="right"><h3>9.</h3> Airflow design rates and run-times shall be determined using ASHRAE 62.2-2010 or later. Designers are permitted, but not required, to use published addenda and/or the 2013 or 2016 version of the standard to assess compliance. </div>
              <b>?</b></sup>
            <div class="ps-3">
              <p class="design-overview-wrapper__item__title">
                Check the box of the applicable cooling sizing limit from the choice below: <i style="color:red;">*</i></p>
            </div>
          </div>
          <mat-radio-group name="coolingsizinglimit" #coolingsizinglimit="ngModel"
            [(ngModel)]="system.coolingsizinglimit" #radioGroup="matRadioGroup" (change)="validateInputs()" (change)="checkCoolingSizeLimit()" (change)="onSelectCompressorSpeed($event.value)"
            [ngModelOptions]="{standalone: false}" required>
            <mat-radio-button value="Single-Speed: Recommended: 90-115% Allowed: 90-130% (Condition A)"
              (change)="system.coolingsizinglimit = $event.value" checked="true" class="me-3">Single-Speed: Recommended:
              90-115% Allowed: 90-130% (Condition A)
            </mat-radio-button>
            <mat-radio-button value="Two-Speed: Recommended: 90-120% Allowed: 90-140% (Condition A)" class="me-3">
              Two-Speed: Recommended: 90-120% Allowed: 90-140% (Condition A)</mat-radio-button>
            <mat-radio-button value="Variable-Speed: Recommended: 90-130% Allowed: 90-160% (Condition A)" class="me-3">
              Variable-Speed: Recommended: 90-130% Allowed: 90-160% (Condition A)</mat-radio-button>
            <mat-radio-button value="(Any Speed): Allowed: 90-100%, plus 15kBtuh (Condition B)" class="me-3">
              (Any Speed): Allowed: 90-100%, plus 15kBtuh (Condition B)</mat-radio-button>
          </mat-radio-group>


          <mat-error *ngIf="systemForm.submitted&& coolingsizinglimit.errors?.required"> Cooling Sizing Limit is
            required
          </mat-error>
        </div>


        <div class="design-overview-wrapper__item">
          <div class="d-flex">
            <div class="pe-3">
              <span class="design-overview-wrapper__item__item-number">
                4.16
              </span>
            </div>
            <div class="ps-3">
              <p class="design-overview-wrapper__item__title">Cooling sizing % (4.13) is within cooling sizing limit
                (4.15) </p>
            </div>
            <div class="ps-3">
              <!--<p class="design-overview-wrapper__item__title">Designer Verified</p> -->
            </div>
          </div>
          <i style="color:red;"><strong>
              <h3>{{system.coolsizepctlimit2}}</h3>
            </strong></i>
          <strong>
            <h3>{{system.coolsizepctlimit3}}</h3>
          </strong>
        </div>


        <div class="row" *ngIf="furnaceInput">

          <div
            style="float: left;width: 100%;padding-top: 15px; padding-left:10px; background-color:#000; height:60px; color:#ffffff;">
            <span class="content-header">
              Furnace
            </span>
          </div>
        </div>

        <div class="design-overview-wrapper__item" *ngIf="furnaceInput">
          <div class="d-flex col-md-6 flex-column">
            <div class="d-flex">
              <div class="pe-3">
                <span class="design-overview-wrapper__item__item-number">
                  4.20
                </span>
              </div>
              <div class="ps-3">
                <p class="design-overview-wrapper__item__title">Heating sizing % = Total capacity (4.19) divided by
                  total heat loss (3.14)</p>
              </div>
              <div>
                <div *ngIf="system.heatsizepctlimits" class="table"> <i style="color:red;">* Total capacity (4.19) And
                    total heat loss (3.14)</i> </div> {{ returnFixed(system.heatsizepctlimits) }}
              </div>
            </div>
          </div>
        </div>

        <div class="design-overview-wrapper__item" *ngIf="furnaceInput">
          <div class="d-flex">
            <div class="pe-3">
              <span class="design-overview-wrapper__item__item-number">
                4.21
              </span>
            </div>
            <div class="ps-3">
              <p class="design-overview-wrapper__item__title">Check box of applicable heating sizing limit from below
                <i style="color:red;">*</i>
              </p>
            </div>
          </div>
          <mat-radio-group #heatsizinglimit="ngModel" (change)="validateInputs()" name="heatsizinglimit" [(ngModel)]="system.heatsizinglimit"
            #radioGroup="matRadioGroup" (change)="checkCoolingSizeLimit()" [ngModelOptions]="{standalone: false}"
            >
            <mat-radio-button value="Used for heating Only: 100-140%" checked="true" class="me-3">Used for heating Only:
              100-140%
            </mat-radio-button>
            <mat-radio-button value="Paired With Cooling: Recommended: 100-140% Allowed 100-200%" class="me-3">Paired
              With Cooling: Recommended: 100-140% Allowed 100-400%</mat-radio-button>
          </mat-radio-group>

          <mat-error class='loadErrors' *ngIf="systemForm.submitted && heatsizinglimit.errors?.required"> heating sizing limit is required
          </mat-error>
        </div>


        <div class="design-overview-wrapper__item" *ngIf="furnaceInput">
          <div class="d-flex">
            <div class="pe-3">
              <span class="design-overview-wrapper__item__item-number">
                4.22
              </span>
            </div>
            <div class="ps-3">
              <p class="design-overview-wrapper__item__title">Heating sizing % (4.20) is within heating sizing limit (4.21). </p>
            </div>
            <div class="ps-3">
              <p class="design-overview-wrapper__item__title">Designer</p>
            </div>
          </div>
          <i style="color:red;"><strong>
              <h3>{{system.heatsizepctlimits2}}</h3>
            </strong></i>
          <strong>
            <h3>{{system.heatsizepctlimits3}}</h3>
          </strong>
        </div>




        <div class="design-overview-wrapper__item">
          <div class="d-flex">
            <div class="pe-3">
              <span class="design-overview-wrapper__item__item-number">
                5.1
              </span>
            </div>
            <div class="ps-3">
              <p class="design-overview-wrapper__item__title">Duct system designed for the equipment selected in Section
                4, per ACCA Manual D <i style="color:red;">*</i></p>
            </div>
          </div>
          <mat-radio-group (change)="validateInputs()" #manuald="ngModel" name="manuald" [(ngModel)]="system.manuald" #radioGroup="matRadioGroup"
            [ngModelOptions]="{standalone: false}" required>
            <mat-radio-button value="Verified" checked="true" class="me-3">Verified
            </mat-radio-button>
            <mat-radio-button value="Not Verified" class="me-3">Not Verified</mat-radio-button>
          </mat-radio-group>

          <mat-error *ngIf="systemForm.submitted&& manuald.errors?.required">This field is required
          </mat-error>
        </div>

        <div class="design-overview-wrapper__item">
          <div class="d-flex">
            <div class="pe-3">
              <span class="design-overview-wrapper__item__item-number tooltip">
                5.2 <div class="right"> <h3>29.</h3> Design HVAC fan airflow is the design airflow for the blower in CFM, as determined using the manufacturer’s expanded performance data.</div>
              </span>
            </div><sup class='supTooltip tooltip'> <div class="right"><h3>9.</h3> Airflow design rates and run-times shall be determined using ASHRAE 62.2-2010 or later. Designers are permitted, but not required, to use published addenda and/or the 2013 or 2016 version of the standard to assess compliance. </div>
              <b>?</b></sup>
            <div class="ps-3">
              <p class="design-overview-wrapper__item__title">Design HVAC Fan Airflow <i style="color:red;">*</i></p>
            </div>
          </div>
          <div class="d-flex flex-wrap row">
            <div class="d-flex col-md-6 flex-column px-3">

              <mat-form-field appearance="fill" floatLabel="always">
                <input matInput type="number" [(ngModel)]="system.designairflowcool" maxlength="9"
                (blur)="validateInputs()" [ngModelOptions]="{standalone: false}" name="designairflowcool"
                  class="example-right-align" placeholder="Condenser Manufacturer" #designairflowcool='ngModel'
                  required>
                <span class="input-group-addon">(CFM) Cooling Mode</span>
              </mat-form-field>
              <mat-error class='loadErrors' *ngIf="systemForm.submitted&& designairflowcool.errors?.required"> Design HVAC fan Airflow is
                required
              </mat-error>
            </div>
            <div class="d-flex col-md-6 flex-column px-3">

              <mat-form-field appearance="fill" floatLabel="always">
                <input matInput type="number" [(ngModel)]="system.designairflowheat" maxlength="9"
                (blur)="validateInputs()" [ngModelOptions]="{standalone: false}" name="designairflowheat"
                  class="example-right-align" placeholder="Condenser Manufacturer" #designairflowheat='ngModel'
                  required>
                <span class="input-group-addon">(CFM) Heating Mode</span>
              </mat-form-field>
              <mat-error class='loadErrors' *ngIf="systemForm.submitted&& designairflowheat.errors?.required"> (CFM) Heating Mode is
                required
              </mat-error>
            </div>
          </div>
        </div>

        <div class="design-overview-wrapper__item">
          <div class="d-flex">
            <div class="pe-3">
              <span class="design-overview-wrapper__item__item-number tooltip">
                5.3 <div class="right"><h3>30.</h3> Design HVAC fan speed setting is the setting on the control board (e.g., low, medium, high) corresponding to the Design HVAC fan airflow. </div>
              </span>
            </div><sup class='supTooltip tooltip'> <div class="right"><h3>9.</h3> Airflow design rates and run-times shall be determined using ASHRAE 62.2-2010 or later. Designers are permitted, but not required, to use published addenda and/or the 2013 or 2016 version of the standard to assess compliance. </div>
              <b>?</b></sup>
            <div class="ps-3">
              <p class="design-overview-wrapper__item__title">HVAC Fan Speed Setting (e.g. low, medium, high)<i
                  style="color:red;">*</i> </p>
            </div>
          </div>
          <div class="d-flex flex-wrap row">
            <div class="d-flex col-md-6 flex-column px-3">

              <mat-form-field appearance="fill">
                <mat-select placeholder="Select Cooling Mode" #hvacfanspdcool="ngModel"
                  [(ngModel)]="system.hvacfanspdcool" (ngModelChange)="validateInputs()"
                  [ngModelOptions]="{standalone: false}" name="fanspeeds" required>
                  <mat-option *ngFor="let coolingMode of fanSpeedMode" [value]="coolingMode">
                    {{coolingMode}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-error class='loadErrors' *ngIf="systemForm.submitted&& hvacfanspdcool.errors?.required"> HVAC Fan Speed Setting (e.g.
                low, medium, high) is required
              </mat-error>
            </div>

            <div class="d-flex col-md-6 flex-column px-3">
              <mat-form-field appearance="fill">
                <mat-select placeholder="Select Heating Mode" #hvacfanspdheat="ngModel"
                  [(ngModel)]="system.hvacfanspdheat" (ngModelChange)="validateInputs()"
                  [ngModelOptions]="{standalone: false}" name="fanspeeds" required>
                  <mat-option *ngFor="let heatingMode of fanSpeedMode" [value]="heatingMode">
                    {{heatingMode}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-error class='loadErrors' *ngIf="systemForm.submitted&& hvacfanspdheat.errors?.required"> HVAC Fan Speed setting (e.g.
                low, medium, high) is required
              </mat-error>
            </div>
          </div>
        </div>

        <div class="design-overview-wrapper__item">
          <div class="d-flex">
            <div class="pe-3">
              <span class="design-overview-wrapper__item__item-number tooltip">
                5.4 <div class="right"><h3>31.</h3> Design total external static pressure is the pressure corresponding to the Design HVAC fan airflow, inclusive of external components (e.g., evaporator coil, whole-house humidifier, or ≥ MERV 6 filter).  </div>
              </span>
            </div><sup class='supTooltip tooltip'> <div class="right"><h3>9.</h3> Airflow design rates and run-times shall be determined using ASHRAE 62.2-2010 or later. Designers are permitted, but not required, to use published addenda and/or the 2013 or 2016 version of the standard to assess compliance. </div>
              <b>?</b></sup>
            <div class="ps-3">
              <p class="design-overview-wrapper__item__title">Design Total External Static Pressure (IWC) <i
                  style="color:red;">*</i></p>
            </div>
          </div>
          <div class="d-flex col-md-6 flex-column">

            <mat-form-field appearance="fill" floatLabel="always">
              <input matInput type="number" [(ngModel)]="system.designstaticp" maxlength="9"
              (blur)="validateInputs()" [ngModelOptions]="{standalone: false}" name="designstaticp"
                class="example-right-align" placeholder="Condenser Manufacturer" #designstaticp='ngModel' required>
              <span class="input-group-addon">Heating Mode</span>
            </mat-form-field>

            <mat-error class='loadErrors' *ngIf="systemForm.submitted&& designstaticp.errors?.required">Design Total External Static
              pressure (IWC) is required
            </mat-error>
          </div>
        </div>

        <div class="design-overview-wrapper__item">
          <div class="d-flex">
            <div class="ps-3">
              <p class="design-overview-wrapper__item__title" style="color:red;">* Required fields
              </p>
            </div>
          </div>
        </div>
        <div class="d-flex my-3">
          <button mat-flat-button color="primary" >
            {{!editMode? 'SAVE AND GO TO 5.5 ROOM-BY-ROOM' : 'Save'}}
          </button>
          <button style="margin-left:20px;" mat-flat-button color="warn" type="button" [routerLink]="['/system']" data-toggle="collapse"
          data-target="#dds3" aria-expanded="false" aria-controls="dds3">
          Cancel
        </button>


        </div>
      </div>
    </form>
  </div>

</div>
